<template>
  <div v-if="contents.length > 0" class="live live01">
    <div class="inner">
      <Title>
        <template #title>
          プレゼントキーワード付き企業LIVE
        </template>
      </Title>
      <div class="description">
        <p>LIVEに参加して3つキーワードを集めよう！キーワードを集めた後は抽選会に応募しよう<br><font color="red">（応募〆切：14:00まで）</font></p>
      </div>
      <div>
        <div class="live-programs"
        >
          <LiveProgram2021
            v-for="(program, idx) in contents"
            :key="idx"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram2021 from '@/components/molecules/2021tsuruha/LiveProgram.vue'
export default {
  props: {
    contents: {},
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram2021
  }
}
</script>

<style lang="sass" scoped>
.live01
  padding: 20px 0 25px
</style>
